const isLocalHost =
  typeof window !== 'undefined' &&
  ['localhost', '127.0.0.1'].includes(window.location.hostname);

const API_BASE_URL = process.env.REACT_APP_API_URL || (isLocalHost ? 'http://localhost:8005/api' : '/api');

export const API_CONFIG = {
  baseURL: API_BASE_URL,
  timeout: 30000,
};

export default API_CONFIG;
